import { nanoid } from 'nanoid';

import { type SelectCellRangeEvent } from '../events/types';
import { type SelectionRange, type SelectionState } from '../state/types';

import { type ReducerResponse } from './types';

export function selectCellRangeReducer(
  state: SelectionState,
  event: SelectCellRangeEvent
): ReducerResponse {
  const newSelection: SelectionRange = {
    id: nanoid(),
    anchor: event.anchor,
    lead: event.lead
  };
  /**
   * The choice here is to keep the focus cell as the anchor,
   * which happens when doing a click / range selection
   */
  const focusedCell = event.anchor;

  return {
    delta: {
      kind: 'selectionReplaced',
      source: event.source,
      selections: [newSelection],
      focusChange: {
        prev: state.focusedCell,
        next: focusedCell
      }
    },
    next: {
      ...state,
      mode: 'cell',
      focusedCell,
      selections: [newSelection],
      lastInteractionSource: event.source
    }
  };
}
